<script setup lang="ts">
/** Form 45B (Consent to Act as Secretary) — 선임 비서 1인당 1부(상위 DocScope 스코프). 원본: Form 45B.docx */
import CddVarField from '@/features/startTask/my_preset/sg/aura/agm/cdd/CddVarField.vue';
import '@/features/startTask/my_preset/sg/aura/agm/docs/agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <p class="sec-title" style="text-align:center">THE COMPANIES ACT 1967<br />SECTION 173C(b)<br />CONSENT TO ACT AS SECRETARY</p>
    <p class="sec-title" style="text-align:right">FORM 45B</p>

    <table class="cdd-tbl" style="width:auto;margin:8px 0">
      <tbody>
        <tr><td class="cdd-lcell">Name of Company:</td><td><CddVarField field-key="company_name" label="Company Name" /></td></tr>
        <tr><td class="cdd-lcell">Company No:</td><td><CddVarField field-key="company_registration_no" label="UEN" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p">1. I, the undermentioned person, hereby consent to act as a secretary of the abovenamed company with effect from
      <CddVarField field-key="appointment_effective_date" label="Appointment effective date" /> (date)</p>

    <p class="doc-p">&dagger; 2. I am a qualified person under section 171 (1AA) of the Companies Act by virtue of my being &ndash;</p>
    <ol class="q-list">
      <li><span class="q-no">*(i)</span> a secretary of a company for at least 3 of the 5 years immediately preceding the abovementioned date of my appointment as secretary of the abovenamed company.</li>
      <li><span class="q-no">*(ii)</span> a qualified person under the Legal Profession Act (Cap. 161).</li>
      <li><span class="q-no">*(iii)</span> a public accountant.</li>
      <li><span class="q-no">*(iiia)</span> a member of the Institute of Singapore Chartered Accountants (formerly known as the Institute of Certified Public Accountants of Singapore).</li>
      <li><span class="q-no">*(iv)</span> a member of the Chartered Secretaries Institute of Singapore.</li>
      <li><span class="q-no">*(v)</span> a member of the Association of International Accountants (Singapore Branch).</li>
      <li><span class="q-no">*(vi)</span> a member of the The Institute of Company Accountants, Singapore.</li>
    </ol>

    <table class="cdd-tbl reg-tbl">
      <tbody>
        <tr><td class="reg-l">Name:</td><td><CddVarField field-key="secretary_name" label="Name" /></td></tr>
        <tr><td class="reg-l">Address:</td><td><CddVarField field-key="secretary_address" label="Address" /></td></tr>
        <tr><td class="reg-l">NRIC/FIN/Passport No:</td><td><CddVarField field-key="secretary_identification_no" label="NRIC/FIN/Passport" /></td></tr>
        <tr><td class="reg-l">Nationality:</td><td><CddVarField field-key="secretary_nationality" label="Nationality" /></td></tr>
      </tbody>
    </table>

    <div class="sign-block" style="margin-top:14px">
      <div>Signature: <span class="sign-line-txt">________________________</span>
        &nbsp;&nbsp;Dated <CddVarField field-key="execution_date" label="Execution date" /></div>
    </div>

    <p class="foot-note">&dagger; To be completed by secretaries of public companies only or by secretaries of private companies appointed under section 171 (1AB) of the Act.</p>
    <p class="foot-note">*Delete where inapplicable.</p>
  </div>
</template>

<style scoped>
.q-list { list-style: none; margin: 4px 0 10px 8px; padding: 0; }
.q-list li { padding: 2px 0; font-size: 11.5px; }
.q-no { display: inline-block; min-width: 46px; font-weight: 600; }
.reg-tbl { width: 100%; border-collapse: collapse; margin: 4px 0; }
.reg-tbl td { border: 1px solid #d3dbe6; padding: 5px 8px; vertical-align: top; }
.reg-l { width: 36%; background: #f7f9fc; font-weight: 600; color: #42506a; }
.sign-line-txt { color: #94a3b8; letter-spacing: 1px; }
.foot-note { font-size: 10.5px; color: #5b6b82; margin: 8px 0 0; }
</style>
